import { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useSelector } from "react-redux";

const pageNo = "RelisoftPage";

function RelisoftPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const roles = useSelector((state) => state.auth.roles);
  const [tabValue, setTabValue] = useState(0);
  const [menuItems, setMenuItems] = useState([
    {
      stt: 0,
      text: "KHÁCH HÀNG",
      path: "/relisoft/khach-hang",
      pageNo: "CustomersPage",
    },
    {
      stt: 1,
      text: "ĐƠN ĐẶT HÀNG",
      path: "/relisoft/don-dat-hang",
      pageNo: "OrdersPage",
    },
    {
      stt: 2,
      text: "BẢNG GIÁ",
      path: "/relisoft/bang-gia",
      pageNo: "PriceListPage",
    },
    {
      stt: 3,
      text: "BÁO CÁO SALE",
      path: "/relisoft/bao-cao-sale",
      pageNo: "SaleReportPage",
    },
    {
      stt: 4,
      text: "CẤU HÌNH SYSTEM",
      path: "/relisoft/cau-hinh-system",
      pageNo: "SystemConfigPage",
    },
    {
      stt: 5,
      text: "AUTOSALE",
      path: "/relisoft/autosale",
      pageNo: "AutoSalePage",
    },
  ]);
  useEffect(() => {
    setTabValue(() => {
      let i = menuItems[0].stt;
      menuItems.map((item, index) => {
        if (
          location.pathname === item.path ||
          (item.path !== "/" && location.pathname.startsWith(item.path + "/"))
        )
          i = item.stt;
      });
      return i;
    });
  }, [location.pathname]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (location.pathname.endsWith("/relisoft"))
      navigate(menuItems[tabValue].path);
  }, [navigate, menuItems, tabValue]);

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Menu Tabs */}
      <Tabs
        value={tabValue}
        onChange={handleChangeTab}
        indicatorColor="primary"
        textColor="primary"
        selectionFollowsFocus
      >
        {menuItems.map((item, index) => {
          return (
            <Tab
              key={item.stt}
              label={item.text}
              value={item.stt}
              onClick={() => {
                navigate(item.path);
              }}
            />
          );
        })}
      </Tabs>

      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default RelisoftPage;
